import { useEffect } from 'react';

export function DarkDynamicIsland() {
    useEffect(() => {
        const tileColorElement = document.querySelector(`meta[name="theme-color"]`) as HTMLMetaElement;
        let originalColor = '#ffffff';
        if (tileColorElement) {
            originalColor = tileColorElement.content;
            tileColorElement.content = '#1b1b1f';
        }
        return () => {
            if (tileColorElement) {
                tileColorElement.content = originalColor;
            }
        };
    }, []);

    return null;
}
